import axios from 'axios';
import { angularService, getAuthHeader } from '../../../../../utils';

const FALLBACK_URL  = 'https://ms.dev.staging-zorallabs.com/api/workflow/GetFieldUsage';

export type GetDataParams = {
  workflowName: string,
  version: number,
  fieldsPath?: string | null
}

const getData = ({ workflowName, version = 0, fieldsPath }: GetDataParams) => {
  const zStatus = angularService('zStatus');
  const URL = zStatus && zStatus.endpoint && zStatus.endpoint.de ? zStatus.endpoint.de + '/workflow/GetFieldUsage' : FALLBACK_URL;
  return axios.get(
    URL, {
      params: { workflowName, version, fieldsPath },
      headers: getAuthHeader()
    });
};

export default getData;
